import * as React from "react";
import ImageView from "../../../../components/SmartImage";
import DiscountInfoCard from "./DiscountInfoCard";
import { BottomViews } from "../BottomViews";
import { PriceViews } from "../PriceViews";
import { NameViews } from "../NameViews";
import { ActTagViewForPc } from "../ActTagViews";
import { ProductCardWrap, DescriptionWrap, LikeIcon, ProductCardPoster } from "./styles";
import { ModuleLayoutStyle } from "../../../../services/playground";
export class ProductCard extends React.PureComponent {
    constructor(props) {
        super(props);
        this.onClick = () => {
            if (this.props.onClick) {
                this.props.onClick();
            }
        };
        this.state = {};
    }
    render() {
        const { product, gridCol, posterRatio = 1, layoutStyle, placeholderBg = "" } = this.props;
        const { imgOnBottomLeft, imgOnTopLeft, imgOnTopRight, titleIcon, collect, actTags } = product.extra || {};
        return (React.createElement(ProductCardWrap, { target: "_blank", width: this.props.width, href: product.url, onClick: this.onClick },
            React.createElement(ProductCardPoster, { posterRatio: posterRatio, layoutStyle: layoutStyle, style: {
                    background: `url(${placeholderBg}) center`,
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    width: this.props.width,
                } },
                React.createElement(DiscountInfoCard, { discountInfo: imgOnTopRight, tagInfo: imgOnTopLeft, themeTag: imgOnBottomLeft }),
                React.createElement(ImageView, { src: product === null || product === void 0 ? void 0 : product.img, online: true, placeholder: placeholderBg, fallbackSrc: placeholderBg, imgClass: "productImage", fit: true })),
            React.createElement(DescriptionWrap, { gridCol: gridCol }, layoutStyle === ModuleLayoutStyle.Orange ? (React.createElement(React.Fragment, null,
                React.createElement(NameViews, { name: product.name, columnNum: actTags ? 1 : 2, titleTag: (titleIcon === null || titleIcon === void 0 ? void 0 : titleIcon.img) || "" }),
                actTags && React.createElement(ActTagViewForPc, { actTags: actTags }),
                React.createElement(PriceViews, { className: `priceView${ModuleLayoutStyle.Orange}`, price: product.price, originPrice: product.originPrice }),
                collect && React.createElement(BottomViews, { columnNum: gridCol, collect: collect }))) : (React.createElement(React.Fragment, null,
                React.createElement("p", { className: "cardTitle" }, product.name),
                React.createElement("div", { className: "currentPrice" }, product.price),
                React.createElement("div", { className: "suffix" },
                    product.price !== product.originPrice && (React.createElement("span", { className: "originPrice" }, product.originPrice)),
                    (collect === null || collect === void 0 ? void 0 : collect.text) && (React.createElement("div", { className: "rightView" },
                        React.createElement(LikeIcon, null),
                        React.createElement("span", null, collect.text)))))))));
    }
}
